import script from "./PaymentButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentButton.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentButton.vue?vue&type=style&index=0&id=754c33d3&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754c33d3"]])

export default __exports__